(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carla-pdp"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('carlita-pdp')) {
    class CarlitaPdp extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.variantRequestController?.abort();
        this.controller = new AbortController();
        this.variantRequestController = null;
        this.variantRequestToken = 0;
        this.cartLoading = false;
        this.resolvedOptionValueIds = new Set(
          Array.from(this.querySelectorAll('[data-cb-option]:checked'))
            .map((input) => input.dataset.optionValueId)
            .filter(Boolean)
        );

        this.bindVariantOptions();
        this.bindGallery();
        this.bindDialogs();
        this.bindQuantity();
        this.bindProductForm();
        this.bindStickyCart();
        this.bindUpsell();
        this.bindPerfectMatch();
        if (this.dataset.manualMetaEvents === 'true') this.bindMetaTracking();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.variantRequestController?.abort();
        this.stickyObserver?.disconnect();
      }

      metaCurrency() {
        return this.dataset.currency || window.Shopify?.currency?.active || 'CLP';
      }

      metaMoneyFromCents(cents) {
        const amount = Number(cents || 0) / 100;
        return Number.isFinite(amount) ? amount : 0;
      }

      metaBaseItem({ variantId, quantity = 1, priceCents = 0 }) {
        const id = String(variantId || '');
        const qty = Math.max(1, Number(quantity) || 1);
        const itemPrice = this.metaMoneyFromCents(priceCents);
        if (!id) return null;
        return {
          id,
          quantity: qty,
          item_price: itemPrice
        };
      }

      trackMeta(eventName, payload = {}, dedupeKey = '') {
        if (this.dataset.manualMetaEvents !== 'true' || typeof window.fbq !== 'function') return false;

        window.__carlitaMetaEventKeys = window.__carlitaMetaEventKeys || new Set();
        if (dedupeKey && window.__carlitaMetaEventKeys.has(dedupeKey)) return false;

        try {
          window.fbq('track', eventName, payload);
          if (dedupeKey) window.__carlitaMetaEventKeys.add(dedupeKey);
          return true;
        } catch (error) {
          console.warn(`[Carlita Meta] No se pudo enviar ${eventName}`, error);
          return false;
        }
      }

      trackMetaViewContent() {
        const variantId = this.dataset.variantId;
        const item = this.metaBaseItem({
          variantId,
          quantity: 1,
          priceCents: this.dataset.productPrice
        });
        if (!item) return;

        const payload = {
          content_ids: [item.id],
          content_type: 'product',
          content_name: this.dataset.productTitle || '',
          content_category: this.dataset.productType || '',
          contents: [item],
          value: item.item_price,
          currency: this.metaCurrency()
        };

        const key = `ViewContent:${this.dataset.productId || item.id}:${window.location.pathname}`;
        this.trackMeta('ViewContent', payload, key);
      }

      trackMetaAddToCart(items = [], options = {}) {
        const normalized = items.filter(Boolean);
        if (!normalized.length) return;

        const value = normalized.reduce((sum, item) => {
          return sum + (Number(item.item_price || 0) * Math.max(1, Number(item.quantity) || 1));
        }, 0);
        const numItems = normalized.reduce((sum, item) => sum + Math.max(1, Number(item.quantity) || 1), 0);

        const payload = {
          content_ids: normalized.map((item) => String(item.id)),
          content_type: 'product',
          contents: normalized,
          value: Number(value.toFixed(2)),
          currency: this.metaCurrency(),
          num_items: numItems
        };

        if (options.contentName) payload.content_name = options.contentName;
        if (options.contentCategory) payload.content_category = options.contentCategory;

        this.trackMeta('AddToCart', payload);
      }

      trackMetaInitiateCheckout() {
        const quantity = Number(
          this.querySelector('[data-cb-qty-input]')?.value ||
          this.querySelector('input[name="quantity"]')?.value ||
          1
        );
        const item = this.metaBaseItem({
          variantId: this.dataset.variantId,
          quantity,
          priceCents: this.dataset.productPrice
        });
        if (!item) return;

        this.trackMeta('InitiateCheckout', {
          content_ids: [item.id],
          content_type: 'product',
          content_name: this.dataset.productTitle || '',
          content_category: this.dataset.productType || '',
          contents: [item],
          value: Number((item.item_price * item.quantity).toFixed(2)),
          currency: this.metaCurrency(),
          num_items: item.quantity
        });
      }

      bindMetaTracking() {
        this.trackMetaViewContent();

        let lastCheckoutTrackAt = 0;
        const maybeTrackCheckout = (event) => {
          const path = typeof event.composedPath === 'function' ? event.composedPath() : [event.target];
          const accelerated = path.some((node) => {
            const matches = node?.matches;
            if (typeof matches !== 'function') return false;
            return matches.call(
              node,
              '.shopify-payment-button__button, .shopify-payment-button__more-options, shopify-accelerated-checkout'
            );
          });

          if (!accelerated) return;
          const now = Date.now();
          if (now - lastCheckoutTrackAt < 1200) return;
          lastCheckoutTrackAt = now;
          this.trackMetaInitiateCheckout();
        };

        this.addEventListener('pointerdown', maybeTrackCheckout, {
          capture: true,
          signal: this.controller.signal
        });
        this.addEventListener('click', maybeTrackCheckout, {
          capture: true,
          signal: this.controller.signal
        });
      }

      bindVariantOptions() {
        this.querySelectorAll('[data-cb-option]').forEach((input) => {
          input.addEventListener('change', (event) => this.changeVariant(event), {
            signal: this.controller.signal
          });
        });
      }

      setVariantLoading(loading) {
        if (loading) {
          this.dataset.loading = 'true';
          this.setAttribute('aria-busy', 'true');
        } else {
          delete this.dataset.loading;
          this.removeAttribute('aria-busy');
        }
      }

      setCartLoading(loading, sourceButton = null) {
        this.cartLoading = loading;
        const buttons = [
          this.querySelector('[data-cb-atc]'),
          this.querySelector('[data-cb-sticky-submit]')
        ].filter(Boolean);

        if (loading) {
          this.dataset.cartLoading = 'true';
          buttons.forEach((button) => {
            button.dataset.cbWasDisabled = button.disabled ? 'true' : 'false';
            button.disabled = true;
            button.setAttribute('aria-busy', 'true');
          });
          const addingText = this.dataset.addingText || 'Agregando…';
          const mainLabel = this.querySelector('[data-cb-atc-label]');
          const stickyLabel = this.querySelector('[data-cb-sticky-label]');
          if (mainLabel) mainLabel.textContent = addingText;
          if (stickyLabel) stickyLabel.textContent = addingText;
          sourceButton?.setAttribute('aria-busy', 'true');
          return;
        }

        delete this.dataset.cartLoading;
        buttons.forEach((button) => {
          const defaultText = button.dataset.defaultText || '';
          button.disabled = button.dataset.cbWasDisabled === 'true';
          button.removeAttribute('aria-busy');
          delete button.dataset.cbWasDisabled;
          const label = button.querySelector('[data-cb-atc-label], [data-cb-sticky-label]');
          if (label && defaultText) label.textContent = defaultText;
        });
        sourceButton?.removeAttribute('aria-busy');
      }

      showVariantError(message = '') {
        const errorBox = this.querySelector('[data-cb-variant-error]');
        if (!errorBox) return;
        if (!message) {
          errorBox.hidden = true;
          errorBox.textContent = '';
          return;
        }
        errorBox.textContent = message;
        errorBox.hidden = false;
      }

      setFormStatus(message = '', type = '') {
        const status = this.querySelector('[data-cb-form-status]');
        if (!status) return;
        status.textContent = message;
        status.classList.toggle('is-error', type === 'error');
        status.classList.toggle('is-success', type === 'success');
      }

      restoreResolvedOptions() {
        if (!this.resolvedOptionValueIds?.size) return;
        this.querySelectorAll('[data-cb-option]').forEach((input) => {
          input.checked = this.resolvedOptionValueIds.has(input.dataset.optionValueId);
        });
      }

      async changeVariant(event) {
        const optionRoot = event.currentTarget.closest('[data-cb-options]');
        if (!optionRoot) return;

        const checked = Array.from(optionRoot.querySelectorAll('[data-cb-option]:checked'));
        const optionCount = Number(this.dataset.optionCount || 0);
        if (!optionCount || checked.length !== optionCount) return;

        const optionValueIds = checked.map((input) => input.dataset.optionValueId).filter(Boolean);
        if (optionValueIds.length !== optionCount) return;

        this.variantRequestController?.abort();
        this.variantRequestController = new AbortController();
        const requestToken = ++this.variantRequestToken;
        const focusId = event.currentTarget.id;
        const connectedProductUrl = event.currentTarget.dataset.connectedProductUrl;
        const baseUrl = connectedProductUrl || this.dataset.productUrl || window.location.pathname;
        const requestUrl = new URL(baseUrl, window.location.origin);
        requestUrl.searchParams.set('section_id', this.dataset.sectionId);
        requestUrl.searchParams.set('option_values', optionValueIds.join(','));

        this.showVariantError('');
        this.setFormStatus('');
        this.setVariantLoading(true);

        try {
          const response = await fetch(requestUrl.toString(), {
            headers: {
              'Accept': 'text/html',
              'X-Requested-With': 'XMLHttpRequest'
            },
            signal: this.variantRequestController.signal
          });
          if (!response.ok) throw new Error(`Variant request failed: ${response.status}`);

          const html = await response.text();
          if (requestToken !== this.variantRequestToken) return;

          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const nextSection = Array.from(parsed.querySelectorAll('carlita-pdp[data-section-id]'))
            .find((element) => element.dataset.sectionId === this.dataset.sectionId);
          if (!nextSection) throw new Error('Updated product section not found');

          const nextVariantId = nextSection.dataset.variantId || nextSection.querySelector('[data-cb-variant-id-input]')?.value;
          if (!nextVariantId) throw new Error('Updated variant ID not found');

          const browserUrl = new URL(baseUrl, window.location.origin);
          browserUrl.searchParams.delete('section_id');
          browserUrl.searchParams.delete('option_values');
          browserUrl.searchParams.set('variant', nextVariantId);

          const currentTop = this.getBoundingClientRect().top;
          this.replaceWith(nextSection);
          window.history.replaceState({}, '', `${browserUrl.pathname}${browserUrl.search}${browserUrl.hash}`);

          window.requestAnimationFrame(() => {
            const nextTop = nextSection.getBoundingClientRect().top;
            const delta = nextTop - currentTop;
            if (Math.abs(delta) > 1) window.scrollBy({ top: delta, behavior: 'auto' });
            if (focusId) document.getElementById(focusId)?.focus({ preventScroll: true });
          });
        } catch (error) {
          if (error?.name === 'AbortError') return;
          if (requestToken !== this.variantRequestToken) return;
          this.restoreResolvedOptions();
          this.setVariantLoading(false);
          this.showVariantError(
            this.dataset.variantErrorText ||
            'No pudimos actualizar esta opción. Intenta nuevamente.'
          );
          console.error('[Carlita PDP] Variant update failed', error);
        }
      }

      bindQuantity() {
        const input = this.querySelector('[data-cb-qty-input]');
        const minus = this.querySelector('[data-cb-qty-minus]');
        const plus = this.querySelector('[data-cb-qty-plus]');
        if (!input) return;

        const clamp = (value) => {
          const min = Number(input.min || 1);
          const max = input.max ? Number(input.max) : Number.POSITIVE_INFINITY;
          const step = Math.max(1, Number(input.step || 1));
          let next = Number.isFinite(Number(value)) ? Number(value) : min;
          next = Math.max(min, Math.min(max, next));
          next = min + Math.round((next - min) / step) * step;
          return Math.max(min, Math.min(max, next));
        };

        const sync = () => {
          const value = clamp(input.value);
          input.value = String(value);
          const min = Number(input.min || 1);
          const max = input.max ? Number(input.max) : Number.POSITIVE_INFINITY;
          if (minus) minus.disabled = input.disabled || value <= min;
          if (plus) plus.disabled = input.disabled || value >= max;
        };

        minus?.addEventListener('click', () => {
          input.value = String(clamp(Number(input.value) - Number(input.step || 1)));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }, { signal: this.controller.signal });

        plus?.addEventListener('click', () => {
          input.value = String(clamp(Number(input.value) + Number(input.step || 1)));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }, { signal: this.controller.signal });

        input.addEventListener('change', sync, { signal: this.controller.signal });
        input.addEventListener('blur', sync, { signal: this.controller.signal });
        sync();
      }

      bindProductForm() {
        const form = this.querySelector('form[data-cb-product-form]');
        if (!form) return;

        form.addEventListener('submit', async (event) => {
          event.preventDefault();
          if (this.cartLoading || this.dataset.loading === 'true') return;

          const submitter = event.submitter || this.querySelector('[data-cb-atc]');
          if (submitter?.disabled) return;

          const variantInput = form.querySelector('[data-cb-variant-id-input]');
          if (!variantInput?.value) {
            this.setFormStatus(this.dataset.cartErrorText || 'Selecciona una variante disponible.', 'error');
            return;
          }

          await this.addFormToCart(form, submitter);
        }, { signal: this.controller.signal });
      }

      async addFormToCart(form, submitter) {
        this.setFormStatus('');
        this.showVariantError('');
        this.setCartLoading(true, submitter);

        try {
          const formData = new FormData(form);
          const sections = (this.dataset.cartSections || '')
            .split(',')
            .map((value) => value.trim())
            .filter(Boolean)
            .slice(0, 5);

          if (sections.length) {
            formData.set('sections', sections.join(','));
            formData.set('sections_url', `${window.location.pathname}${window.location.search}`);
          }

          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: formData
          });

          const data = await response.json().catch(() => ({}));
          if (!response.ok) {
            throw new Error(data?.description || data?.message || this.dataset.cartErrorText || 'No pudimos agregar el producto.');
          }

          if (data?.sections) this.applyReturnedSections(data.sections);

          const mainItem = this.metaBaseItem({
            variantId: formData.get('id'),
            quantity: formData.get('quantity') || 1,
            priceCents: this.dataset.productPrice
          });
          this.trackMetaAddToCart([mainItem], {
            contentName: this.dataset.productTitle || '',
            contentCategory: this.dataset.productType || ''
          });

          const cart = await this.getCart();
          if (cart) {
            this.updateCartCount(cart.item_count);
            document.dispatchEvent(new CustomEvent('carlita:cart:updated', {
              detail: { cart, source: 'product-page' }
            }));
            document.dispatchEvent(new CustomEvent('cart:updated', {
              detail: { cart, source: 'product-page' }
            }));
          }

          document.dispatchEvent(new CustomEvent('carlita:cart:add', {
            detail: {
              productId: this.dataset.productId,
              variantId: formData.get('id'),
              response: data
            }
          }));
          document.dispatchEvent(new CustomEvent('cart:refresh', {
            detail: { source: 'product-page' }
          }));

          this.setFormStatus(this.dataset.addedText || 'Agregado al carrito.', 'success');

          if (this.dataset.autoOpenCart === 'true') {
            await this.openCartAfterAdd();
          }
        } catch (error) {
          const message = error?.message || this.dataset.cartErrorText || 'No pudimos agregar el producto.';
          this.setFormStatus(message, 'error');
          console.error('[Carlita PDP] Add to cart failed', error);
        } finally {
          this.setCartLoading(false, submitter);
        }
      }

      async getCart() {
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart.js`, {
            headers: {
              'Accept': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            }
          });
          if (!response.ok) return null;
          return await response.json();
        } catch (error) {
          console.warn('[Carlita PDP] Could not refresh cart count', error);
          return null;
        }
      }

      updateCartCount(count) {
        const selectors = [
          '[data-cbh-cart-count]',
          '[data-cart-count]',
          '.header__cart-count',
          '.cart-count-bubble [aria-hidden="true"]',
          '.cart-count-bubble span:first-child'
        ];

        document.querySelectorAll(selectors.join(',')).forEach((node) => {
          node.textContent = String(count);
          node.removeAttribute('hidden');
        });

        document.querySelectorAll('.cart-count-bubble').forEach((bubble) => {
          bubble.classList.toggle('is-empty', count <= 0);
          if (count > 0) bubble.removeAttribute('hidden');
        });
      }

      applyReturnedSections(sections) {
        Object.entries(sections).forEach(([sectionId, html]) => {
          if (!html) return;
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const replacement = parsed.getElementById(`shopify-section-${sectionId}`);
          const current = document.getElementById(`shopify-section-${sectionId}`);
          if (replacement && current && !current.contains(this)) {
            current.replaceWith(replacement);
          }
        });
      }

      async openCartAfterAdd() {
        await new Promise((resolve) => window.requestAnimationFrame(resolve));

        const customTrigger = document.querySelector('[data-cbh-open-cart]');
        if (customTrigger instanceof HTMLElement) {
          customTrigger.click();
          return;
        }

        const directTriggerCandidate = document.querySelector(
          '[data-open-cart], [data-cart-drawer-open], button[aria-controls="cart-drawer"], button[aria-controls*="CartDrawer"], .header-actions__cart-icon'
        );
        const directTrigger = directTriggerCandidate?.closest?.('button, a') || directTriggerCandidate;
        if (directTrigger instanceof HTMLElement) {
          directTrigger.click();
          return;
        }

        const drawers = [
          document.querySelector('theme-drawer#cart-drawer'),
          document.querySelector('cart-drawer'),
          document.querySelector('#CartDrawer'),
          document.querySelector('[data-cart-drawer]')
        ].filter(Boolean);

        for (const drawer of drawers) {
          try {
            if (typeof drawer.open === 'function') {
              drawer.open();
              return;
            }
            if (typeof drawer.show === 'function') {
              drawer.show();
              return;
            }
            if (typeof drawer.showModal === 'function') {
              drawer.showModal();
              return;
            }
          } catch (error) {
            console.debug('[Carlita PDP] Drawer API unavailable', error);
          }
        }

        const cartLink = document.querySelector('a[href$="/cart"], a[href*="/cart?"]');
        if (cartLink instanceof HTMLElement) {
          cartLink.click();
          return;
        }

        const root = window.Shopify?.routes?.root || '/';
        window.location.assign(`${root}cart`);
      }

      bindUpsell() {
        const button = this.querySelector('[data-cb-upsell-add]');
        if (!button) return;

        button.addEventListener('click', async () => {
          if (button.disabled || this.cartLoading) return;
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
          this.setFormStatus('');

          try {
            const root = window.Shopify?.routes?.root || '/';
            const sections = (this.dataset.cartSections || '')
              .split(',')
              .map((value) => value.trim())
              .filter(Boolean)
              .slice(0, 5);

            const payload = {
              items: [{ id: Number(button.dataset.variantId), quantity: 1 }]
            };

            if (sections.length) {
              payload.sections = sections.join(',');
              payload.sections_url = `${window.location.pathname}${window.location.search}`;
            }

            const response = await fetch(`${root}cart/add.js`, {
              method: 'POST',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify(payload)
            });

            const data = await response.json().catch(() => ({}));
            if (!response.ok) throw new Error(data?.description || data?.message || 'No pudimos agregar el complemento.');
            if (data?.sections) this.applyReturnedSections(data.sections);

            const upsellItem = this.metaBaseItem({
              variantId: button.dataset.variantId,
              quantity: 1,
              priceCents: button.dataset.price
            });
            this.trackMetaAddToCart([upsellItem], {
              contentName: button.dataset.productTitle || '',
              contentCategory: button.dataset.productType || ''
            });

            const cart = await this.getCart();
            if (cart) this.updateCartCount(cart.item_count);
            this.setFormStatus(this.dataset.addedText || 'Agregado al carrito.', 'success');

            document.dispatchEvent(new CustomEvent('carlita:cart:add', {
              detail: { variantId: button.dataset.variantId, response: data, upsell: true }
            }));
            document.dispatchEvent(new CustomEvent('cart:refresh', {
              detail: { source: 'product-upsell' }
            }));

            if (this.dataset.autoOpenCart === 'true') await this.openCartAfterAdd();
          } catch (error) {
            this.setFormStatus(error?.message || 'No pudimos agregar el complemento.', 'error');
          } finally {
            button.disabled = false;
            button.removeAttribute('aria-busy');
          }
        }, { signal: this.controller.signal });
      }

      bindGallery() {
        const gallery = this.querySelector('[data-cb-gallery]');
        const items = Array.from(this.querySelectorAll('[data-cb-media-item]'));
        const thumbnails = Array.from(this.querySelectorAll('[data-cb-thumbnail]'));
        const thumbs = this.querySelector('[data-cb-thumbs]');
        const prev = this.querySelector('[data-cb-thumbs-prev]');
        const next = this.querySelector('[data-cb-thumbs-next]');
        const mainPrev = this.querySelector('[data-cb-main-prev]');
        const mainNext = this.querySelector('[data-cb-main-next]');
        const desktopCurrent = this.querySelector('[data-cb-desktop-current]');

        const stopMedia = (item) => {
          item?.querySelectorAll('video').forEach((video) => video.pause());
          item?.querySelectorAll('model-viewer').forEach((model) => model.pause?.());
          item?.querySelectorAll('iframe').forEach((iframe) => {
            try {
              iframe.contentWindow?.postMessage(JSON.stringify({
                event: 'command',
                func: 'pauseVideo',
                args: ''
              }), '*');
              iframe.contentWindow?.postMessage({ method: 'pause' }, '*');
            } catch (error) {
              console.debug('[Carlita PDP] Unable to pause external media', error);
            }
          });
        };

        const stopInactiveMedia = (activeIndex) => {
          items.forEach((item, index) => {
            if (index !== activeIndex) stopMedia(item);
          });
        };

        const activateDesktopMedia = (index, focusThumbnail = false) => {
          const item = items[index];
          const thumbnail = thumbnails[index];
          if (!item || !gallery) return;

          items.forEach((mediaItem, mediaIndex) => {
            mediaItem.classList.toggle('is-active', mediaIndex === index);
          });

          thumbnails.forEach((thumb, thumbIndex) => {
            const active = thumbIndex === index;
            thumb.classList.toggle('is-active', active);
            if (active) thumb.setAttribute('aria-current', 'true');
            else thumb.removeAttribute('aria-current');
          });

          stopInactiveMedia(index);
          gallery.dataset.activeMediaId = item.dataset.mediaId || '';
          if (desktopCurrent) desktopCurrent.textContent = String(index + 1);

          if (thumbnail && thumbs) {
            const targetLeft = thumbnail.offsetLeft - Math.max(0, (thumbs.clientWidth - thumbnail.offsetWidth) / 2);
            thumbs.scrollTo({ left: targetLeft, behavior: 'smooth' });
          }

          if (focusThumbnail) thumbnail?.focus({ preventScroll: true });
        };

        thumbnails.forEach((thumbnail, index) => {
          thumbnail.addEventListener('click', () => activateDesktopMedia(index), {
            signal: this.controller.signal
          });
        });

        const stepMainMedia = (direction) => {
          if (!items.length) return;
          const currentIndex = Math.max(0, items.findIndex((item) => item.classList.contains('is-active')));
          const nextIndex = (currentIndex + direction + items.length) % items.length;
          activateDesktopMedia(nextIndex);
        };

        mainPrev?.addEventListener('click', () => stepMainMedia(-1), { signal: this.controller.signal });
        mainNext?.addEventListener('click', () => stepMainMedia(1), { signal: this.controller.signal });

        gallery?.addEventListener('keydown', (event) => {
          if (!window.matchMedia('(min-width: 990px)').matches) return;
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            stepMainMedia(-1);
          }
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            stepMainMedia(1);
          }
        }, { signal: this.controller.signal });

        const updateArrowState = () => {
          if (!thumbs) return;
          const maxScroll = Math.max(0, thumbs.scrollWidth - thumbs.clientWidth - 2);
          if (prev) prev.disabled = thumbs.scrollLeft <= 2;
          if (next) next.disabled = thumbs.scrollLeft >= maxScroll;
        };

        const scrollThumbnails = (direction) => {
          if (!thumbs) return;
          const amount = Math.max(180, thumbs.clientWidth * .72) * direction;
          thumbs.scrollBy({ left: amount, behavior: 'smooth' });
        };

        prev?.addEventListener('click', () => scrollThumbnails(-1), { signal: this.controller.signal });
        next?.addEventListener('click', () => scrollThumbnails(1), { signal: this.controller.signal });
        thumbs?.addEventListener('scroll', updateArrowState, {
          signal: this.controller.signal,
          passive: true
        });
        window.requestAnimationFrame(updateArrowState);

        if (!gallery) return;

        let ticking = false;
        let lastMobileIndex = Math.max(0, items.findIndex((item) => item.classList.contains('is-active')));

        gallery.addEventListener('scroll', () => {
          if (window.matchMedia('(min-width: 990px)').matches || ticking) return;
          ticking = true;

          window.requestAnimationFrame(() => {
            const galleryRect = gallery.getBoundingClientRect();
            const galleryAnchor = galleryRect.left + parseFloat(getComputedStyle(gallery).paddingLeft || '0');
            let closestIndex = 0;
            let closestDistance = Number.POSITIVE_INFINITY;

            items.forEach((item, index) => {
              const distance = Math.abs(item.getBoundingClientRect().left - galleryAnchor);
              if (distance < closestDistance) {
                closestDistance = distance;
                closestIndex = index;
              }
            });

            const current = this.querySelector('[data-cb-gallery-current]');
            if (current) current.textContent = String(closestIndex + 1);

            if (closestIndex !== lastMobileIndex) {
              stopInactiveMedia(closestIndex);
              lastMobileIndex = closestIndex;
            }

            ticking = false;
          });
        }, {
          signal: this.controller.signal,
          passive: true
        });

        const activeIndex = items.findIndex((item) => item.classList.contains('is-active'));
        if (activeIndex >= 0) {
          if (window.matchMedia('(max-width: 989px)').matches) {
            window.requestAnimationFrame(() => {
              const target = items[activeIndex];
              if (target) {
                const paddingLeft = parseFloat(getComputedStyle(gallery).paddingLeft || '0');
                gallery.scrollTo({
                  left: Math.max(0, target.offsetLeft - paddingLeft),
                  behavior: 'auto'
                });
              }
              const current = this.querySelector('[data-cb-gallery-current]');
              if (current) current.textContent = String(activeIndex + 1);
              stopInactiveMedia(activeIndex);
            });
          } else {
            stopInactiveMedia(activeIndex);
          }
        }
      }

      bindDialogs() {
        const zoomDialog = this.querySelector('[data-cb-zoom-dialog]');
        const zoomImage = this.querySelector('[data-cb-zoom-image]');

        this.querySelectorAll('[data-cb-zoom]').forEach((button) => {
          button.addEventListener('click', () => {
            if (!zoomDialog || !zoomImage) return;
            zoomImage.src = button.dataset.imageSrc || '';
            zoomDialog.showModal();
          }, { signal: this.controller.signal });
        });

        this.querySelector('[data-cb-zoom-close]')?.addEventListener('click', () => {
          zoomDialog?.close();
        }, { signal: this.controller.signal });

        zoomDialog?.addEventListener('click', (event) => {
          if (event.target === zoomDialog) zoomDialog.close();
        }, { signal: this.controller.signal });

        zoomDialog?.addEventListener('close', () => {
          if (zoomImage) zoomImage.removeAttribute('src');
        }, { signal: this.controller.signal });

        const sizeDialog = this.querySelector('[data-cb-size-guide-dialog]');
        let sizeGuideTrigger = null;

        this.querySelectorAll('[data-cb-size-guide-open]').forEach((button) => {
          button.addEventListener('click', () => {
            if (!sizeDialog || typeof sizeDialog.showModal !== 'function') return;
            sizeGuideTrigger = button;
            if (!sizeDialog.open) sizeDialog.showModal();
          }, { signal: this.controller.signal });
        });

        this.querySelector('[data-cb-size-guide-close]')?.addEventListener('click', () => {
          if (sizeDialog?.open) sizeDialog.close();
        }, { signal: this.controller.signal });

        sizeDialog?.addEventListener('click', (event) => {
          if (event.target === sizeDialog && sizeDialog.open) sizeDialog.close();
        }, { signal: this.controller.signal });

        sizeDialog?.addEventListener('close', () => {
          sizeGuideTrigger?.focus({ preventScroll: true });
          sizeGuideTrigger = null;
        }, { signal: this.controller.signal });
      }

      bindStickyCart() {
        const sticky = this.querySelector('[data-cb-sticky-mobile]');
        const mainAtc = this.querySelector('[data-cb-main-atc]');
        const stickyButton = this.querySelector('[data-cb-sticky-submit]');
        const form = this.querySelector('form[data-cb-product-form]');
        if (!sticky || !mainAtc || !stickyButton || !form) return;

        stickyButton.addEventListener('click', () => {
          if (stickyButton.disabled || this.cartLoading || this.dataset.loading === 'true') return;
          const submitter = form.querySelector('[data-cb-atc]');
          if (submitter && !submitter.disabled) form.requestSubmit(submitter);
        }, { signal: this.controller.signal });

        const updateStickyVisibility = () => {
          if (!window.matchMedia('(max-width: 989px)').matches) {
            sticky.classList.remove('is-visible');
            return;
          }

          const atcRect = mainAtc.getBoundingClientRect();
          const sectionRect = this.getBoundingClientRect();
          const bottomGuard = Math.max(96, sticky.offsetHeight + 20);
          const shouldShow = atcRect.bottom < 0 && sectionRect.bottom > bottomGuard;
          sticky.classList.toggle('is-visible', shouldShow);
        };

        window.addEventListener('scroll', updateStickyVisibility, {
          signal: this.controller.signal,
          passive: true
        });
        window.addEventListener('resize', updateStickyVisibility, {
          signal: this.controller.signal,
          passive: true
        });
        window.requestAnimationFrame(updateStickyVisibility);
      }

      bindPerfectMatch() {
        const bundle = this.querySelector('[data-cb-bundle-root]');
        if (!bundle) return;
        const button = bundle.querySelector('[data-cb-bundle-add]');
        const total = bundle.querySelector('[data-cb-bundle-total]');
        const status = bundle.querySelector('[data-cb-bundle-status]');
        const choices = Array.from(bundle.querySelectorAll('[data-cb-match-choice]'));
        const basePrice = Number(bundle.dataset.basePrice || 0);
        const active = () => choices.find(choice => choice.querySelector('[data-cb-match-radio]')?.checked);
        const selectedVariant = () => {
          const input = active()?.querySelector('[data-cb-match-variant]');
          const option = input?.selectedOptions?.[0];
          return {id: option?.value || input?.value, price: Number(option?.dataset.price || input?.dataset.price || 0), available: !option?.disabled};
        };
        const sync = () => {
          const variant = selectedVariant();
          if (total) total.textContent = new Intl.NumberFormat('es-CL', {style: 'currency', currency: this.metaCurrency(), maximumFractionDigits: 0}).format((basePrice + variant.price) / 100);
          button.disabled = !variant.id || !variant.available || this.dataset.variantAvailable !== 'true';
        };
        bundle.addEventListener('change', sync, {signal: this.controller.signal});
        sync();
        button.addEventListener('click', async () => {
          if (button.disabled || this.cartLoading || this.dataset.loading === 'true') return;
          const primaryId = Number(this.dataset.variantId);
          const variant = selectedVariant();
          const secondaryId = Number(variant.id);
          if (!primaryId || !secondaryId) return;
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
          if (status) status.textContent = '';
          try {
            const root = window.Shopify?.routes?.root || '/';
            const sections = (this.dataset.cartSections || '').split(',').map(v => v.trim()).filter(Boolean).slice(0, 5);
            const payload = {items: [{id: primaryId, quantity: 1}, {id: secondaryId, quantity: 1}]};
            if (sections.length) {
              payload.sections = sections.join(',');
              payload.sections_url = window.location.pathname + window.location.search;
            }
            const response = await fetch(`${root}cart/add.js`, {
              method: 'POST', headers: {'Accept': 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest'}, body: JSON.stringify(payload)
            });
            const data = await response.json().catch(() => ({}));
            if (!response.ok) throw new Error(data.description || data.message || 'No pudimos agregar ambos productos.');
            if (data.sections) this.applyReturnedSections(data.sections);
            this.trackMetaAddToCart([
              this.metaBaseItem({variantId: primaryId, priceCents: basePrice}),
              this.metaBaseItem({variantId: secondaryId, priceCents: variant.price})
            ]);
            const cart = await this.getCart();
            if (cart) {
              this.updateCartCount(cart.item_count);
              document.dispatchEvent(new CustomEvent('carlita:cart:updated', {detail: {cart, source: 'product-bundle'}}));
              document.dispatchEvent(new CustomEvent('cart:updated', {detail: {cart, source: 'product-bundle'}}));
            }
            document.dispatchEvent(new CustomEvent('carlita:cart:add', {detail: {productId: this.dataset.productId, variantId: primaryId, bundledVariantId: secondaryId, bundle: true, response: data}}));
            document.dispatchEvent(new CustomEvent('cart:refresh', {detail: {source: 'product-bundle'}}));
            if (status) status.textContent = 'Ambos productos se agregaron al carrito.';
            if (this.dataset.autoOpenCart === 'true') await this.openCartAfterAdd();
          } catch (error) {
            if (status) status.textContent = error?.message || 'No pudimos agregar ambos productos.';
          } finally {
            button.removeAttribute('aria-busy');
            sync();
          }
        }, {signal: this.controller.signal});
      }
    }

    customElements.define('carlita-pdp', CarlitaPdp);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
